import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rl-more-info',
  templateUrl: './more-info.component.html',
  styleUrls: ['./more-info.component.scss']
})
export class MoreInfoComponent {
  @Input() text: string;

  toggleMsg: boolean = false;
  constructor() {}

  clickToggle(event: any) {
    if (event.keyCode === 27) {
      this.toggleMsg = true;
    }
    // tab - popup will show
    else if (event.keyCode === 9) {
      this.toggleMsg = false;
    }
  }
}
